const RECIPES_NAV_HIDE_AFTER_DATE = '2026-05-18'

export const wasUserCreatedAfterDate = (
    user: Pick<Models.User, 'created_at'> | null | undefined,
    date: string,
): boolean => {
    const createdDate = user?.created_at?.slice(0, 10)

    if (!createdDate) {
        return false
    }

    return createdDate > date
}

export const shouldShowRecipesNavItem = (user: Models.User | null | undefined): boolean => {
    // Recipes are being faded out for newly-created accounts in favor of Segments.
    return !wasUserCreatedAfterDate(user, RECIPES_NAV_HIDE_AFTER_DATE)
}
